import React, { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  Typography,
} from '@lockerpm/design';
  
import {
  formatText
} from '../../utils/common'
    
import {
  CopyOutlined,
  CheckOutlined,
  EyeOutlined,
  EyeInvisibleOutlined
} from '@ant-design/icons';

const TextCopy = (props) => {
  const {
    className = '',
    value = '',
    color = '',
    align = 'start',
    limited = true,
    show = null,
    defaultShow = null,
    onCopy = () => {}
  } = props;

  const { t } = useTranslation();
  const locale = useSelector((state) => state.system.locale);

  const [isHover, setIsHover] = useState(false)
  const [showText, setShowText] = useState(false)

  useEffect(() => {
    setShowText(show)
  }, [show])

  useEffect(() => {
    setShowText(defaultShow === null ? show : defaultShow)
  }, [])

  const icons = useMemo(() => {
    if (isHover) {
      return [
        <CopyOutlined/>,
        <CheckOutlined/>
      ]
    }
    return [
      <></>,
      <></>
    ]
  })

  const stringValue = useMemo(() => {
    const str = value?.toString();
    if (str && str === `[object Object]`) {
      return ''
    }
    return str
  }, [value])

  const DisplayValue = useMemo(() => {
    if (value) {
      if (show != null) {
        return <div
          style={{ color: color }}
          className={`flex items-center justify-${align} w-full text-black-500`}
        >
          <p
            className={`${limited ? 'text-limited' : ''}`}
            title={formatText(stringValue, showText)}
            style={{ marginBottom: 0 }}
          >
            {formatText(stringValue, showText)}
          </p>
          <span
            className="ml-2 cursor-pointer"
            onClick={() => setShowText(!showText)}
          >
            {
              !showText ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          </span>
        </div>
      }
      return <div
        className={`${limited ? 'text-limited' : ''} text-black-500`}
        style={{ color: color }}
        title={stringValue}
      >
        {value}
      </div>
    }
    return <></>
  }, [
    value,
    align,
    show,
    showText,
    locale
  ])

  return (
    <Typography.Text
      className={`text-copy flex items-center cursor-pointer justify-${align} ${className}`}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      copyable={{
        icon: icons,
        onCopy: onCopy,
        tooltips: [
          t('common.copy'),
          t('common.copied')
        ],
        text: value
      }}
    >
      {DisplayValue}
    </Typography.Text>
  );
}

export default TextCopy;